import classNames from 'classnames';
import { Admin } from '../../../clients/quipli-service/admin/admin';
import { Divider } from '../../../components/divider/divider';
import Icon from '../../../components/icons/icon';
import { SearchBar } from '../../../components/search-bar/search-bar';
import { NumberChip } from '../../../components/tab-nav-v2/tab-nav-request';
import { Typography } from '../../../components/typography/typography';
import { DispatchCards, DispatchCategory } from '../hooks/use-dispatch-v2-data';
import { CardType, OrderCard } from '../../home/dashboard-v2/order-card';
import { Location } from '../../../clients/quipli-service/location/location';
import '../dispatch-v2.scss';
import { useState } from 'react';

export const UnassignedDispatches = ({
  categories,
  toggleCategoryVisibility,
  reload,
  allLocations,
  unitTrackingViaUnitNum,
  allDrivers,
  handleDragStart,
  handleDragEnd,
}: {
  categories: DispatchCategory[];
  toggleCategoryVisibility: (label: string) => void;
  reload: any;
  allLocations: Location[];
  unitTrackingViaUnitNum: boolean;
  allDrivers: Admin[];
  handleDragStart: (e: { dataTransfer: any }, item: any) => void;
  handleDragEnd: (e: any) => void;
}) => {
  const [keyword, setKeyword] = useState<{ keyword?: string | undefined }>({ keyword: '' });

  const filterDispatchCards = (dispatchCards: DispatchCards[], keyword: string | undefined) => {
    return dispatchCards.filter((dc) => {
      const od = dc.mappedOrderData;
      return (
        keyword === undefined ||
        keyword === '' ||
        `${od?.order.products?.map((p) =>
          p.assignedUnits?.map((au) => au?.unitNumber?.toString().toLocaleLowerCase()),
        )} ${od?.order.products?.map((p) =>
          p.assignedUnits?.map((au) => au?.serialNumber?.toString().toLocaleLowerCase()),
        )} ${od?.shippingAddress?.toLocaleLowerCase()} ${od?.orderNumber?.toLocaleLowerCase()} ${od?.customerName.toLocaleLowerCase()} ${od?.order.orderNumber?.toLocaleLowerCase()} ${od?.order.products
          .map((p) => p.name)
          .toString()
          .toLocaleLowerCase()}`.includes(keyword.toLocaleLowerCase())
      );
    });
  };

  return (
    <div className="unassigned-container">
      <div className="p-2">
        <SearchBar
          inputClassName="md:w-full"
          data-cy="search-unassigned"
          placeholder="Search ..."
          value={keyword.keyword}
          setRequest={(keyword) => {
            setKeyword(keyword);
          }}
        />
      </div>
      <Divider />
      <div className="categories-wrapper">
        {categories.map((category, index) => (
          <div
            key={index}
            className={classNames(
              'category-container',
              category.isExpanded && category.dispatchCards.length > 0 ? 'open' : 'closed',
            )}
          >
            <div className="category-header" onClick={() => toggleCategoryVisibility(category.label)}>
              <div className="category-title">
                <Typography type={'text-md'}>{category.label}</Typography>
                <div className="number-chip">
                  <NumberChip
                    tabName={{ name: '', count: filterDispatchCards(category.dispatchCards, keyword?.keyword).length }}
                    selectedTab="no"
                  />
                </div>
              </div>
              <div className="category-action">
                <Icon
                  icon="ChevronUp"
                  className={classNames('chevron', category.isExpanded ? 'chevron-up' : 'chevron-down')}
                />
              </div>
            </div>
            <div className={classNames('category-item', category.isExpanded ? 'open' : 'closed')}>
              {filterDispatchCards(category.dispatchCards, keyword?.keyword).map((dc, index) => (
                <div
                  key={index}
                  className="dispatch-card"
                  draggable={true}
                  onDragStart={(e) => handleDragStart(e, dc)}
                  onDragEnd={handleDragEnd}
                >
                  {dc.mappedOrderData && (
                    <OrderCard
                      orderCardDetails={dc.mappedOrderData}
                      onReload={reload}
                      location={allLocations.find((l) => l.id === dc.mappedOrderData?.order.locationId)}
                      unitTrackingViaUnitNum={unitTrackingViaUnitNum}
                      drivers={allDrivers}
                      cardType={CardType.Dispatch}
                    />
                  )}
                </div>
              ))}
            </div>
            <Divider />
          </div>
        ))}
      </div>
    </div>
  );
};
